import { connect } from 'react-redux'
import { selectBuyingReportRoute } from 'src/store/selectors/layout'

const withToBuyingReport = connect(
  state => ({
    to: selectBuyingReportRoute(state)
  }),
  () => ({})
)

export default withToBuyingReport
